import get from 'lodash/get'

import { ReduxState } from '../types'

export const getClientInfoForm = (state: ReduxState) => get(state, 'form.ClientInfo.values')

export const getClientAddressForm = (state: ReduxState) => get(state, 'form.ClientAddress.values')

export const getClientDetailsForm = (state: ReduxState) => get(state, 'form.ClientDetails.values')

export const getFinanceIncomeForm = (state: ReduxState) => get(state, 'form.FinanceIncome.values')

export const getFinanceExpensesForm = (state: ReduxState) =>
  get(state, 'form.FinanceExpenses.values')

export const getFinanceEmployerForm = (state: ReduxState) =>
  get(state, 'form.FinanceEmployer.values')

export const getFinanceProfessionForm = (state: ReduxState) =>
  get(state, 'form.FinanceProfession.values')

export const getClientAdditionalInfoForm = (state: ReduxState) =>
  get(state, 'form.ClientAdditionalInfo.values')

export const getLoanPreConfiguratorForm = (state: ReduxState) =>
  get(state, 'form.LoanPreConfigurator.values')

export const getRecapitulationFooterForm = (state: ReduxState) =>
  get(state, 'form.RecapitulationFooter.values')

export const getLoanConfiguratorForm = (state: ReduxState) =>
  get(state, 'form.LoanConfigurator.values')

export const getCacheAuthForm = (state: ReduxState) => get(state, 'form.CacheAuth.values')
